module.exports = __webpack_public_path__ + "b216a6c2902685805f909c836661248b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/earrings-flower.png
// module id = 2799
// module chunks = 0